











import { Component, Prop, Vue } from "vue-property-decorator";

import { ChallengeResult } from "@/models/definitions";
import { getOrientation } from "@/utils/exif";

@Component
export default class WrappedImage extends Vue {
  @Prop({ required: true }) readonly challengeResult!: ChallengeResult;
  @Prop({ default: "" }) readonly suffix!: string;

  get image(): string {
    if (this.challengeResult && this.challengeResult.submission) {
      return (
        process.env.VUE_APP_API_ROOT_URL +
        "submissions/" +
        this.challengeResult.submission.image +
        this.suffix +
        ".jpeg"
      );
    } else {
      return "";
    }
  }

  get orientation() {
    if (this.challengeResult && this.challengeResult.submission) {
      const exifRotation = this.challengeResult
        ? getOrientation(this.challengeResult.submission)
        : 1;

      if (exifRotation == 6) {
        return "right";
      } else if (exifRotation == 8) {
        return "left";
      }
    }
    return "top";
  }
}
